<div *ngIf="prop" class="container-fluid d-flex flex-row pt-2">
  <mat-form-field>
    <mat-icon matPrefix color="primary">filter_list</mat-icon>
    <mat-label>Filtrer</mat-label>
    <mat-select #filtersSelect [(value)]="filters" (selectionChange)="filterChange($event.value)" multiple>
      <mat-option *ngFor="let type of trackingHelper.getNonEEMOEventTypes()" [value]="type">
        {{ trackingHelper.getPropertyEventTypeName(type) }}
      </mat-option>
      <mat-option value="EEMO">
        Événements EEMO
      </mat-option>
    </mat-select>
  </mat-form-field>
  <span class="spacer"></span>
  <!--<button *ngIf="userHelper.canUpdateProperty(prop)" mat-mini-fab color="primary" mat-icon-button
    (click)="addTimelineEvent()">
    <mat-icon appTooltip="Ajouter un événement">add</mat-icon>
  </button>-->
</div>
<ng-container *ngIf="!loading; else dataLoading">
  <ng-container *ngIf="events.length>0; else noEvent">
    <app-timeline [events]="events" (updateTriggered)="edit($event)"
      (deleteTriggered)="confirmDeleteEvent($event)"></app-timeline>
  </ng-container>
</ng-container>

<ng-template #dataLoading>
  <app-data-loading></app-data-loading>
</ng-template>

<ng-template #noEvent>
  <div class="container-fluid text-center mt-5">
    <p class="mt-5 text-white">
      Créer votre 1er événement en cliquant sur
    </p>
    <p>
      <button class="mt-2 white" mat-mini-fab color="primary" (click)="addTimelineEvent()">
        <mat-icon aria-label="Ajouter un nouvel événement">add</mat-icon>
      </button>
    </p>
  </div>
</ng-template>